<template>
    <ValidationProvider
        :mode="validationMode"
        :name="label || name || 'unknown'"
        :rules="rules"
        :vid="id"
        v-slot="{ validated, valid, errors }"
        slim
    >
        <rkm-form-group
            :invalid-feedback="errors[0]"
            :state="rules ? (validated ? valid : null) : null"
            :class="{ 'placeholder-label': label === false }"
        >
            <label
                v-if="label"
                :for="id"
            >
                <slot name="label-leading" />

                {{ label + (rules && rules.required ? ' *' : '') }}

                <slot name="label-trailing" />
            </label>

            <rkm-input-group
                :append="append"
                :large="groupLarge"
                :prepend="prepend"
                :small="groupSmall"
            >
                <template v-if="!prepend && $slots.prepend" v-slot:prepend>
                    <slot name="prepend" />
                </template>

                <b-form-select
                    :disabled="disabled"
                    :id="id"
                    :multiple="multiple"
                    :options="options"
                    :size="size"
                    :state="rules ? (validated ? valid : null) : null"
                    :text-field="textField"
                    :value-field="valueField"
                    :value="value"
                    @change="$emit('change', $event)"
                    @input="$emit('input', $event)"
                >
                    <template v-if="showDefaultOption">
                        <rkm-form-select-option
                            slot="first"
                            :value="null"
                        >
                            {{ defaultOptionText }}
                        </rkm-form-select-option>
                    </template>

                    <slot
                        v-else
                        name="first"
                        slot="first"
                    />

                    <slot />
                </b-form-select>

                <template v-if="!append && $slots.append" v-slot:append>
                    <slot name="append" />
                </template>
            </rkm-input-group>
        </rkm-form-group>
    </ValidationProvider>
</template>

<script>
import { BFormSelect } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate';

export default {
    components: { BFormSelect, ValidationProvider },
    computed: {
        size() {
            return this.small ? 'sm' : (this.large ? 'lg' : (''))
        },
        id() {

            // TODO: Centralizar e a tratar melhor a string, removendo caracteres especiais, acentos, etc.
            const id = (this.label || this.name || 'unknown')
                .toLowerCase()
                .replace(/[()\\/\-<>]/gi, '')
                .replace(/[\s]/gi, '-')

            return this.uniqueId(id)
        },
        rules() {

            return this.disabled ? null : this.validations
        }
    },
    props: {
        append: { type: String, default: null },
        disabled: { type: Boolean },
        groupLarge: { type: Boolean, default: false },
        groupSmall: { type: Boolean, default: false },
        label: { type: [String, Boolean], default: '' },
        large: { type: Boolean, default: false },
        multiple: { type: Boolean, default: false },
        name: { type: String },
        options: { type: [Array, Object], default: () => [] },
        prepend: { type: String, default: null },
        showDefaultOption: { type: Boolean, default: false },
        defaultOptionText: { type: String, default: 'Selecione' },
        small: { type: Boolean, default: false },
        state: { type: Boolean, default: null },
        textField: { type: String, default: 'text' },
        validationMode: { type: String, default: 'lazy' },
        validations: { type: Object, default: null },
        value: { type: [ Array, Boolean, Number, Object, String ] },
        valueField: { type: String, default: 'value' },
    },
}
</script>